import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ProcessosEmAbertoCard from './components/ProcessosEmAbertoCard';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const VagasProcessoEmAbertoMain = () => {
  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Processos em Aberto'
        }]} />
        </Col>
      </Row>
      
      <Row>
        <Col md={12}>
          <ProcessosEmAbertoCard />
        </Col>
      </Row>
    </Container>;
};

export default VagasProcessoEmAbertoMain;
